export const GAINSIGHT_APP_AE = 'AE'
export const GAINSIGHT_APP_BPM = 'BPM'

export const productSelectionCustomEventName =
    'Product Selection - Product Added To Project With Parameters'

export const saveGainsightEvent = (
    userDetailsObject: any,
    accountDetailsObject: any
) => {
    // @ts-ignore
    window.aptrinsic('identify', userDetailsObject, accountDetailsObject)
}

export const saveGainsightTrackingEvent = (
    customEventName: string,
    customEventObject: any
) => {
    // @ts-ignore
    window.aptrinsic('track', customEventName, customEventObject)
}
